import { render, staticRenderFns } from "./MallGroupForm.vue?vue&type=template&id=1aab60d2&"
import script from "./MallGroupForm.vue?vue&type=script&lang=js&"
export * from "./MallGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports